import React from 'react';
import PropTypes from 'prop-types';
import { compose, withState } from 'recompose';
import chevronIcon from 'assets/img/chevronDown.png';
import ErrorPopup from '../ErrorPopup';

import './style.scss';

const DropdownField = ({
  filters,
  selected,
  setSelected,
  isDropdownOpen,
  setDropdownOpen,
  label,
  input: {
    onChange,
  },
  meta: {
    touched,
    error,
  },
}) => (
  <div className="dropdown-field" onClick={() => setDropdownOpen(!isDropdownOpen)}>
    <div className="dropdown-field__input">
      <div className="dropdown-field__input__element">
        {Object.keys(selected).length ? <div>{selected.name}</div> : label }
      </div>
      <img className="dropdown-field__input__chevron" src={chevronIcon} alt="" />
    </div>
    {isDropdownOpen ?
      <div className="dropdown-field__list">
        {filters.map(filter =>
          <div
            key={filter.id}
            className="dropdown-field__list__element"
            onClick={() => {
              setSelected(filter);
              onChange(filter.id);
            }}
          >
            {filter.name}
          </div>,
        )}
      </div> : null}
    {touched && error && <ErrorPopup text={error} />}
  </div>
);

DropdownField.propTypes = {
  label: PropTypes.string.isRequired,
  selected: PropTypes.object.isRequired,
  setSelected: PropTypes.func.isRequired,
  filters: PropTypes.array.isRequired,
  isDropdownOpen: PropTypes.bool.isRequired,
  setDropdownOpen: PropTypes.func.isRequired,

  input: PropTypes.shape({
    value: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired,
  }).isRequired,

  meta: PropTypes.shape({
    touched: PropTypes.any,
    error: PropTypes.any,
  }).isRequired,
};

export default compose(
  withState('selected', 'setSelected', {}),
  withState('isDropdownOpen', 'setDropdownOpen', false),
)(DropdownField);



// WEBPACK FOOTER //
// ./src/components/ui/Fields/DropdownField/index.js